import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Loader, Card, Table, Icon, Input, Button } from 'semantic-ui-react'

import './TranscriptionPage.css'

import TranscriptionStatus from '../components/TranscriptionStatus'
import { s3Get } from '../libs/awsLib'
import actions from '../redux/actions'
import Transcript from './Transcript'

class TranscriptionPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      audioFileUrl: null,
      title: null
    }
  }

  componentDidMount () {
    this.loadAudioFileUrl()
    this.setInitialTitle()

    const { transcriptionId, getTranscription } = this.props
    this._intervalId = setInterval(
      () => getTranscription(transcriptionId),
      30000
    )
    getTranscription(transcriptionId)
  }

  componentWillUnmount () {
    if (this._intervalId) {
      clearInterval(this._intervalId)
    }
  }

  componentDidUpdate () {
    this.loadAudioFileUrl()
    this.setInitialTitle()
  }

  loadAudioFileUrl = async () => {
    const { transcription } = this.props
    if (this.audioFileUrlLoading || !transcription || this.state.audioFileUrl) {
      return
    }

    this.audioFileUrlLoading = true
    const audioFileUrl = await s3Get(transcription.s3Key)
    this.audioFileUrlLoading = false

    audioFileUrl && this.setState({ audioFileUrl })
  }

  setInitialTitle = () => {
    const { transcription } = this.props

    if (transcription && this.state.title == null) {
      this.setState({ title: transcription.title })
    }
  }

  render () {
    const { transcription, isLoading, isUpdating } = this.props
    const { audioFileUrl } = this.state

    if (isLoading) {
      return <Loader active>Loading</Loader>
    }

    const status = transcription.transcriptionJob
      ? transcription.transcriptionJob.TranscriptionJobStatus
      : 'pending'

    const isComplete = status === 'COMPLETED'

    return (
      <div className='TranscriptionPage'>
        <Card fluid>
          <Card.Content>
            <Card.Header>
              <div style={{ float: 'left', lineHeight: '1.8em' }}>
                Transcription Details
              </div>
              <Button
                floated='right'
                primary
                disabled={!this.canSave()}
                loading={isUpdating}
                onClick={this.saveChanges}
              >
                Save changes
              </Button>
            </Card.Header>
          </Card.Content>
          <Card.Content>
            <Table padded unstackable className='TranscriptionPage-table'>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width={6}>
                    <div className='TranscriptionPage-label'>
                      Title
                    </div>
                    <div className='TranscriptionPage-value'>
                      <Input
                        id='title'
                        type='text'
                        onChange={this.handleChange}
                        fluid
                        value={this.state.title || ''}
                        disabled={isUpdating}
                      />
                    </div>
                  </Table.Cell>

                  <Table.Cell width={6}>
                    <div className='TranscriptionPage-label'>
                      Speaker Identification
                    </div>
                    <div className='TranscriptionPage-value'>
                      {transcription.speakerIdentification
                        ? `Enabled (${transcription.numSpeakers || 0} Speakers)`
                        : 'Disabled'}
                    </div>
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    <div className='TranscriptionPage-label'>
                      Status
                    </div>
                    <div className='TranscriptionPage-value'>
                      <TranscriptionStatus transcription={transcription} />
                    </div>
                  </Table.Cell>

                  <Table.Cell>
                    <div className='TranscriptionPage-label'>
                      Channel Identification
                    </div>
                    <div className='TranscriptionPage-value'>
                      {transcription.channelIdentification
                        ? 'Enabled'
                        : 'Disabled'}
                    </div>
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell colSpan={2} collapsing={false}>
                    <div className='TranscriptionPage-label'>
                      Audio file
                    </div>
                    {audioFileUrl &&
                      <audio controls style={{ width: '100%' }}>
                        <source src={audioFileUrl} type='audio/mpeg' />
                      </audio>}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Card.Content>
        </Card>

        {isComplete &&
          <Card fluid>
            <Card.Content>
              <Card.Header>
                Transcript
              </Card.Header>
            </Card.Content>

            <Card.Content>
              <Transcript transcription={transcription} />
            </Card.Content>
          </Card>}
      </div>
    )
  }

  handleChange = event =>
    this.setState({ [event.target.id]: event.target.value })

  canSave = () => {
    const { title } = this.state
    const { transcription } = this.props

    return [
      transcription,
      title,
      transcription && transcription.title !== title
    ].every(Boolean)
  }

  saveChanges = () => {
    const { title } = this.state
    const { transcription } = this.props

    if (!transcription || !title) {
      return
    }

    this.props.updateTranscription(transcription.transcriptionId, { title })
  }
}

const mapStateToProps = (state, ownProps) => ({
  transcription: state.transcriptions.data[
    ownProps.match.params.transcriptionId
  ],
  transcriptionId: ownProps.match.params.transcriptionId,
  isLoading: state.transcriptions.isLoading,
  isUpdating: state.transcriptions.isUpdating
})

const mapDispatchToProps = dispatch => ({
  updateTranscription: (transcriptionId, data) =>
    dispatch(actions.transcriptions.update(transcriptionId, data)),
  getTranscription: transcriptionId =>
    dispatch(actions.transcriptions.get(transcriptionId))
})

export default connect(mapStateToProps, mapDispatchToProps)(TranscriptionPage)



// WEBPACK FOOTER //
// ./src/containers/TranscriptionPage.js